// User personal information
export const USER_INFO = {
  name: "Eli Campos",
  initials: "EC",
  email: "elibobcoder.821@gmail.com",
  roles: [
    "Senior FullStack Engineer",
    "Senior FrontEnd Engineer",
    "FrontEnd Architect",
  ],
  github: "elibobcoder",
  githubUrl: "https://github.com/elibobcoder",
  codepenUrl: "https://codepen.io/elicampos-821",
};

export const SITE_CONFIG = {
  preloaderDuration: 1200, // milliseconds
  resumeFileName: "Eli_Campos_Resume.pdf",
  openToWork: true,
  // Shows the GitHub contribution heatmap (uses the github username above).
  showContributions: true,
};

export const EMAILJS_CONFIG = {
  serviceId: "service_c0tmx4g",
  templateId: "template_4z0qrog",
  publicKey: "E0WF6g7hKl94EGKf-",
};
